import axios from "axios";
import { getCsrfToken, setCsrfToken, getSessionRevision, SESSION_EXPIRED_EVENT } from "./session";

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3000",
  timeout: 200000,
  withCredentials: true,
});
api.interceptors.request.use((config) => {
  (config as typeof config & { sessionRevision: number }).sessionRevision = getSessionRevision();
  config.headers = config.headers || {};
  config.headers["X-Insecta-Client"] = "web";
  const csrfToken = getCsrfToken();
  if (csrfToken) config.headers["X-CSRF-Token"] = csrfToken;
  return config;
});
api.interceptors.response.use(response => response, error => {
  const status = error?.response?.status;
  const url = error?.config?.url;
  if (status === 401 && url !== "/login" && url !== "/verify-mfa" && error.config?.sessionRevision === getSessionRevision()) {
    setCsrfToken(null);
    window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
  } else if (status === 403) {
    error.isPermissionDenied = true;
  } else if (status === 429) {
    error.isRateLimited = true;
    error.userMessage = "Muitas tentativas. Aguarde alguns minutos antes de tentar novamente.";
  }
  return Promise.reject(error);
});
